<script setup lang="ts">
  import { onMounted, watch } from "vue";
  import { useTheme } from "./useTheme";
  import { Theme } from "./types";

  const { initialTheme, currentTheme, addThemeMediaQueryListener, removeThemeMediaQueryListener } = useTheme();

  onMounted(initialTheme);

  watch(currentTheme, (newTheme) => {
    if (newTheme === Theme.SYSTEM) {
      addThemeMediaQueryListener();
    } else {
      removeThemeMediaQueryListener();
    }
  });
</script>

<template></template>
